import {
  Component,
  computed,
  effect,
  inject,
  input,
  signal,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import {
  SurveyPage,
  SurveyRenderControllerStore,
} from '@hyper-inferno/survey-elements-core-ui';
import { ENV } from '@hyper-inferno/hyper-base-ng';
import { ChatMessage } from '@hyper-inferno/survey-elements-core-utils';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

@Component({
  imports: [SurveyPage, CommonModule],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  console_api_url = inject(ENV).consoleApi;

  private route = inject(ActivatedRoute);
  private http = inject(HttpClient);

  // 2. Signals for State Management
  composedPage = computed(() => this.renderController.currentPageState());
  themeStyles = signal<any>({});
  loading = signal<boolean>(false);

  private renderController = inject(SurveyRenderControllerStore);

  // These automatically stay in sync with the URL params
  lang = input<string>('en');

  // Convert the Observable queryParams into a reactive Signal
  // This extracts 'pageId' specifically

  page_id = toSignal(
    this.route.queryParams.pipe(map((params) => params['page_id'])),
  );

  constructor() {
    // This will log every time the URL in the iframe changes
    effect(() => {
      // console.log('Active Page ID Signal:', this.page_id());
      if (this.page_id()) {
        this.fetchPreview(this.page_id(), this.lang());
      }
    });
  }

  private fetchPreview(pageId: number, lang: string) {
    this.loading.set(true);
    this.http
      .get<ChatMessage>(
        this.console_api_url + `/preview/page/?page_id=${pageId}&lang=${lang}`,
      )
      .subscribe({
        next: (chatMessage) => {
          // this.re
          // this.composedPage.set(res.page);
          this.renderController.setupCurrentPage(chatMessage.page);

          this.loading.set(false);
        },
        error: () => this.loading.set(false),
      });
  }
}
